"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dismissNotificationActionMutation = exports.notificationActionsQuery = void 0;
exports.notificationActionsQuery = `
query($id: Int!) {
  coachTrainee(id: $id) {
     currentPeriod {
      plan {
        fullName
      }
    }
    notifications {
      id
      type
      canBeDismissed
    }
  }
}`;
exports.dismissNotificationActionMutation = `
    mutation dismissNotification($id: ID!) {  
        dismissNotification(id: $id) {
            success
        }
    }
`;
//# sourceMappingURL=customerNotificationActions.js.map